/**
 * Api.Constant.ts
 * This Component is used to define endpoint commonly.
 */

export const ApiSignin = "/signIn";
export const OTPSumbission = "/requestOTP";
// Configuration End Points
export const GetCountryList = "/Config/GetCountryList";
export const GetStateList = "/Config/GetStateList";
export const GetDistrictList = "/Config/GetDistrictList";
export const GetConfigParamDataList = "/Config/GetConfigParamDataList";
export const GetConfigGroups = "/Config/GetConfigGroups";
export const AddEditConfigGroup = "/Config/AddEditConfigGroup";
export const GetSpecificConfigGroup = "/Config/GetSpecificConfigGroup";
export const GetSpecificConfigParamData = "/Config/GetSpecificConfigParamData";
export const AddEditConfigInfo = "/Config/AddEditConfigInfo";
export const GetMenuHierarchyList = "/Config/GetMenuHierarchyList";
export const GetChunkAPICountDtl = "/Config/GetChunkAPICountDtl";

export const UploadDocs = "/uploadDocs";

// USER MANAGEMENT
export const GetUserList = "/UserManagement/GetUserList";
export const AddEditUser = "/addEditUser";
export const SignUp = "/signUp";
export const GetSpecificUserData = "/getSpecificUser";
export const GetRoleList = "/UserManagement/GetRoleList";
export const GetSpecificRoleInformation =
  "/UserManagement/GetSpecificRoleInformation";
export const AddOrUpdateRoleInformation =
  "/UserManagement/AddOrUpdateRoleInformation";
export const RegisterOtherUser = "/registerOtherUser";

// Customer Module End Points
export const GetCustomerList = "/Project/GetCustomerList";
export const AddEditCustomer = "/Project/AddEditCustomer";
export const GetSpecificCustomerData = "/Project/GetSpecificCustomerData";
export const AddEditCustomerPartnerMapping =
  "/Project/AddEditCustomerPartnerMapping";

// Dealer Module End Points
export const GetDealerList = "/Project/GetDealerList";
export const GetSpecificDealerMasterData =
  "/Project/GetSpecificDealerMasterData";
export const GetDealerMasterList = "/Project/GetDealerMasterList";
export const AddEditDealer = "/Project/AddEditDealer";
export const GetSpecificDealerData = "/Project/GetSpecificDealerData";
export const AddEditDealerPartnerMapping =
  "/Project/AddEditDealerPartnerMapping";

// Service Partner End Points

// Bulk Upload End Points
export const ImportDealerList = "/BulkUpload/ImportDealerList";
export const ImportTicketList = "/BulkUpload/ImportTicketList";
export const ImportEngineerList = "/BulkUpload/ImportEngineerList";
export const SaveBulkDealerList = "/BulkUpload/SaveBulkDealerList";
export const ApproveADL = "/BulkUpload/ApproveADL";
export const GetBulkUploadSample = "/Reports/GetBulkUploadSample";
export const GetADLErrorReport = "/Reports/GetADLErrorReport";
export const GetTicketCount = "/Reports/GetTicketCount";
export const GetTicketTypeCount = "/Reports/GetTicketTypeCount";
export const GetTicketUploadSample = "/Reports/GetTicketUploadSample";
export const GetEngineerUploadSample = "/Reports/GetEngineerUploadSample";
export const GetUploadedADLData = "/Reports/GetUploadedADLData";
export const GetTicketBulkDataReport = "/Reports/GetTicketBulkDataReport";
export const GetEnggBulkDataReport = "/Reports/GetEnggBulkDataReport";
export const GetServiceInstallationReport =
  "/Reports/GetServiceInstallationReport";
export const GetDealerActiveAssetReport = "/Reports/GetDealerActiveAssetReport";
export const GetYearlyDealerReport = "/Reports/GetYearlyDealerReport";
export const GetSLAReport = "/Reports/GetSLAReport";
export const GetTicketProgressReport = "/Reports/GetTicketProgressReport";
// Ticket Module End Points
export const AddEditTicket = "/Ticket/AddEditTicket";
export const GetTicketList = "/Ticket/GetTicketList";
export const GetSpecificTicket = "/Ticket/GetSpecificTicket";
export const GetSpecificTicketAMCApproval =
  "/Ticket/GetSpecificTicketAMCApproval";
export const AddEditTicketAMCApproval = "/Ticket/AddEditTicketAMCApproval";
export const ReassignTicket = "/Ticket/ReassignTicket";
export const GetSpareDepHistory = "/Ticket/GetSpareDepHistory";
export const AddEditSpareDependency = "/Ticket/AddEditSpareDependency";

// Product Module End Points
export const GetProductList = "/Project/GetProductList";
export const AddEditProduct = "/Product/AddEditProduct";
export const GetSpecificProductList = "/Product/GetSpecificProductList";

// Holiday List End Points
export const GetHolidayList = "/Config/GetAllCalendarEvents";
export const AddHolidays = "/Config/AddCalendarEvent";
export const UpdateHolidays = "/Config/UpdateCalendarEvent";
export const DeleteHolidays = "/Config/DeleteCalendarEvent";
export const GetHolidayById = "/Config/GetCalendarEventById";
export const UpdateChunkAPICount = "/Config/UpdateChunkAPICount";

// Config-state End Points
export const AddEditState = "/Config/AddEditState";
export const AddDistrict = "/Config/AddDistrict";
export const UpdateDistrict = "/Config/UpdateDistrict";
export const GetGroupById = "/Config/GetGroupById";
export const GetIssueCategoryList = "/Config/GetIssueCategoryList";
export const AddEditIssueCategory = "/Config/AddEditIssueCategory";

// Config-spare End Points
export const GetSpareList = "/Product/GetSpareList";
export const AddEditSpare = "/Product/AddEditSpare";
export const GetSpecificSpare = "/Product/GetSpecificSpare";
export const GetSpareProductList = "/Product/GetSpareProductList";

// Logs End Points
export const GetAuditLogList = "/Config/GetAuditLogList";

//Dashboard End Points

export const SendAlerts = "/sendAlerts";
export const ExportDocuments = "/exportDocs";
export const ExportMultiplePdfs = "/exportMultiplePdfs";
export const ExportSinglePdf = "/exportSinglePdf";

//Landing Page
export const CreateForm = "/createUserFormMaster";

//Form
export const updateField = "/updateUserForm";
export const GetFormData = "/getUserFormById";
export const GetUserForms = "/getUserForms";

//Admin
export const getUsersData = "/getDashboardData";
export const updateFormStatus = "/updateFormStatus";
export const ExportExcel = "/exportExcel";
export const GetRemarks = "/getRemarks";
export const StudentDataExport = "/studentDataExport";
export const TeacherDataExport = "/teacherDataExport";
export const SchoolDataExport = "/schoolDataExport";

//Timeline
export const addEditTimeline = "/addEditTimeline";
export const getTimeline = "/getTimelines";

//Add Admin
export const addAdmin = "/addAdmin";
export const AddComment = "/addEditRemarks";
export const DeleteComment = "/deleteRemark";
